import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { Get, Post } from "../Axios/AxiosFunctions";
import BodyLoader from "../Components/BodyLoader";
import { apiHeader, imageUrl, URL, validateEmail } from "../Config/apiUrl";

const ContactUs = ({ setfooterStyle }) => {
  const history = useHistory();
  const [pageData, setPageData] = useState(null);
  const [isApiCall, setIsApiCall] = useState(true);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [input, setInput] = useState({
    name: "",
    lastname: "",
    email: "",
    contactNo: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };
  const contactUsData = URL(`general/contact-us`);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = URL(`general/support`);
    const params = {
      name: input?.name.trim(),
      email: input?.email.trim(),
      message: input?.message.trim(),
    };

    for (let key in params) {
      if (params[key] == "") {
        return toast.warn(`${key} can not be empty.`);
      }
    }

    if (!validateEmail(params?.email)) {
      return toast.warn("Please input a valid email address.");
    }

    if (params?.message?.length < 10) {
      return toast.warn("Message should be atleast 10 characters long.");
    }

    setIsSubmittingForm(true);
    const response = await Post(url, params, apiHeader());
    setIsSubmittingForm(false);
    if (response !== undefined) {
      toast.success(
        "Thankyou for contacting Jobster! Our team will respond you shortly."
      );
      setInput({
        name: "",
        lastname: "",
        email: "",
        contactNo: "",
        message: "",
      });
    }
  };

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  // getdata
  const getdata = async () => {
    const url = URL("general/web/selected-page?name=contact_us");
    const response = await Get(url);
    if (response !== undefined) {
      setPageData(response?.data?.data?.contact_us);
    }

    setIsApiCall(false);
  };

  useEffect(() => {
    getdata();
  }, []);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <div>
      <div
        className="contactus_banner whito text-center"
        style={{
          backgroundImage: `url(${imageUrl}${pageData?.cover_image})`,
        }}
      >
        <Container>
          <Row>
            <Col>
              <h2>{pageData?.heading}</h2>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="contactForm_main">
        <Row>
          <Col>
            <div className="contact_form_width">
              <div className="contact_form_innerWidth">
                <Row>
                  <Col className="text-center mb-3">
                    <h4 className="contact_form_heading ">Contact Form</h4>
                  </Col>
                </Row>
                <form onSubmit={handleSubmit}>
                  <Row className="form_row mt-5">
                    <Col md={12} className="mb-4">
                      <Form.Control
                        type="text"
                        placeholder="First Name"
                        name="name"
                        value={input.name}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                    {/* <Col md={6} className="mb-4">
                      <Form.Control
                        type="text"
                        placeholder="Last Name"
                        name="lastname"
                        value={input.lastname}
                        required
                        onChange={handleChange}
                      />
                    </Col> */}
                    <Col md={12} className="mb-4">
                      <Form.Control
                        type="email"
                        placeholder="Email Address"
                        name="email"
                        value={input.email}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                    {/* <Col md={6} className="mb-4">
                      <Form.Control
                        type="text"
                        placeholder="Contact Number"
                        name="contactNo"
                        value={input.contactNo}
                        required
                        onChange={handleChange}
                      />
                    </Col> */}
                    <Col md={12} className="mb-4 text-area">
                      <Form.Control
                        as="textarea"
                        placeholder="Message"
                        name="message"
                        value={input.message}
                        required
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-center">
                        <Button disabled={isSubmittingForm} type="submit">
                          {isSubmittingForm ? "Please Wait..." : "Submit"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;
